@if (filteredList && filteredList.length > 0) {
  <div class="flex flex-column gap-1">
    @for (poi of filteredList; track poi.key) {
      <div
        class="flex align-items-center justify-content-between py-2 px-3 border-round hover:surface-100 cursor-pointer transition-colors transition-duration-150"
        [class.surface-200]="poi.key === activeKey"
        [class.shadow-1]="poi.key === activeKey"
        (click)="poiClick(poi)">
        <div class="flex align-items-center overflow-hidden">
          <i
            class="fas fa-location-dot text-xs mr-2"
            [class.text-primary]="poi.key === activeKey"
            [class.text-400]="poi.key !== activeKey"></i>
          <span
            class="text-sm font-medium overflow-hidden text-overflow-ellipsis white-space-nowrap"
            [pTooltip]="poi.name"
            tooltipPosition="top">
            {{ poi.name }}
          </span>
        </div>
        <div class="flex gap-1 ml-2">
          <p-button
            [rounded]="true"
            [text]="true"
            icon="fas fa-eye"
            styleClass="p-button-xs"
            (click)="poiClick(poi)"
            pTooltip="Auf Karte zeigen"
            tooltipPosition="left" />
          @if (activeUserStore.canUseAccessibility()) {
            <p-button
              [rounded]="true"
              [text]="!isIsochroneActive(poi)"
              [severity]="isIsochroneActive(poi) ? 'primary' : 'secondary'"
              icon="fas fa-route"
              styleClass="p-button-xs"
              (click)="toggleIsochrone($event, poi)"
              pTooltip="Erreichbarkeit"
              tooltipPosition="left" />
          }
        </div>
      </div>
    }
  </div>
}
